<template>
  <div class="sticky-navigation">
    Menu
  </div>
</template>

<script>
  export default {
    name: 'AppHeader'
  }
</script>

<style>
  .sticky-navigation {
    height: 65vh;
    padding: 15px 0;
    background: var(--app-color-dark-green);
    z-index: 99;
  }
</style>